import { createFileRoute } from '@tanstack/react-router';
import { CertificatePage } from '@/features/metric-hub/training/CertificatePage';

/**
 * Per-user training certificate — checklist of the four requirements, the
 * gated test, and a certificate preview + PDF download once earned. Visible to
 * every authenticated user (lives in the Metric Hub "Learn" sidebar group).
 */
export const Route = createFileRoute('/_authed/metric-hub/certificate')({
  component: CertificatePage,
});
